import { statementDetails } from '@/utils/translations';

/**
 * Formats the "Particulars, Code, Reference" line shown in payment statement details,
 * substituting a placeholder for any part the payer left blank.
 */
export const buildStatementLine = (
  particulars?: string | null,
  code?: string | null,
  reference?: string | null
) =>
  [
    particulars || statementDetails.noParticulars,
    code || statementDetails.noCode,
    reference || statementDetails.noReference
  ].join(', ');
